import * as ExcelJS from 'exceljs';
import { Button } from '@mui/material';
import saveAs from 'file-saver';
import useNotification from './notification';
import { ReactComponent as TemplateIcon } from '../assets/icons/main/template-icon.svg';
import { upperCase } from 'lodash';

const fileType = '.xlsx';
const FileExport = (props: any) => {

    const { isTemplate, exportData, exportFileName, style, entityName } = props;
    const [msg, sendNotification] = useNotification();

    async function exTest() {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet("Sheet1");

        let curDate = new Date();
        let dateFormat = `${curDate.getHours()}-${curDate.getMinutes()}-${curDate.getSeconds()}`;
        const fileName = (exportFileName) ? exportFileName + '_' + dateFormat : dateFormat;

        let colData: any = [];
        let worksheetColumns: any = []

        if (isTemplate) {
            if (exportData) {
                colData = exportData;
                for (let data in colData) {
                    if (typeof colData[data] === 'string') {
                        // worksheetColumns.push({ header: (entityName) ? entityName.toUpperCase()+' '+data.split('_')[1].toUpperCase() : data.replace('_', ' ').toUpperCase() , key: data, width: (data.length + 5), color: 'red' })
                        worksheetColumns.push({ header: data ? upperCase(data) : data.replace('_', ' ').toUpperCase() , key: data, width: (data.length + 5), color: 'red' })
                    }
                }
                worksheet.columns = worksheetColumns;
                worksheet.eachRow({ includeEmpty: true }, function (row:any, rowNumber:any) {
                    row.eachCell(function (cell:any, colNumber:any) {
                        if (rowNumber == 1) {
                            cell.font = {
                                bold: false,
                                size: 10,
                            };
                            cell.alignment = {
                                vertical: 'middle', horizontal: 'center'
                            };
                            cell.fill = {
                                type: 'pattern',
                                pattern: 'solid',
                                fgColor: { argb: 'C7C7C7' }
                            };
                            cell.border = {
                                top: { style: 'thin' },
                                // left: { style: 'thin' },
                                bottom: { style: 'thin' },
                                // right: { style: 'thin' }
                            };
                        }

                    });
                });
                workbook.xlsx.writeBuffer().then((data: any) => {
                    const blob = new Blob([data], {
                        type:
                            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                    });
                    saveAs(blob, fileName + fileType);
                }).catch((err:any) => {
                    sendNotification({ msg: "Error occured during excel creation [" + err.message + "]", variant: 'error' })
                });
            } else {
                sendNotification({ msg: "Invalid configuration", variant: 'error' })
            }
        } else {
            if (exportData.length > 0) {
                colData = exportData[0];
                for (let data in colData) {
                    worksheetColumns.push({ header: (entityName)? entityName.toUpperCase()+ data.split('_')[1].toUpperCase() : data.replace('_', ' ').toUpperCase(), key: data, width: (data.length + 5) })
                }
                worksheet.columns = worksheetColumns;

                exportData.forEach((element: any) => {
                    worksheet.addRow(element);
                });
                worksheet.eachRow({ includeEmpty: true }, function (row:any, rowNumber:any) {
                    row.eachCell(function (cell:any, colNumber:any) {
                        if (rowNumber == 1) {
                            cell.font = {
                                bold: false,
                                size: 10,
                            };
                            cell.alignment = {
                                vertical: 'middle', horizontal: 'center'
                            };
                            cell.fill = {
                                type: 'pattern',
                                pattern: 'solid',
                                fgColor: { argb: 'C7C7C7' }
                            };
                            cell.border = {
                                top: { style: 'thin' },
                                bottom: { style: 'thin' },
                            };
                        }

                    });
                });
                workbook.xlsx.writeBuffer().then((data: any) => {
                    const blob = new Blob([data], {
                        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                    });
                    saveAs(blob, fileName + fileType);
                }).catch((err:any) => {
                    sendNotification({ msg: "Error occured during excel creation [" + err.message + "]", variant: 'error' })
                });


            } else {
                sendNotification({ msg: "Invalid data", variant: 'error' })
            }
        }
    };

    return (<Button variant="outlined" startIcon={<TemplateIcon />} onClick={exTest} sx={style}>Download Template</Button>)
}

export default FileExport;